import React, { memo } from 'react';
import Skeleton, { SkeletonCard } from '../Skeleton';

const GuideBuilderSkeleton: React.FC = memo(() => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="h-20 bg-white border-b border-gray-200 flex items-center justify-between px-6">
        <div className="flex items-center space-x-4">
          <Skeleton width={32} height={32} className="rounded-lg" />
          <Skeleton width={200} height={24} />
        </div>
        <div className="flex items-center space-x-2">
          <Skeleton width={100} height={36} className="rounded-lg" />
          <Skeleton width={100} height={36} className="rounded-lg" />
        </div>
      </div>
      <div className="flex h-[calc(100vh-80px)]">
        <div className="w-80 bg-white border-r border-gray-200 p-6">
          <Skeleton height={32} className="mb-6" />
          <div className="space-y-4">
            {[...Array(3)].map((_, i) => (
              <SkeletonCard key={i} />
            ))}
          </div>
        </div>
        <div className="flex-1 p-6">
          <Skeleton height={400} className="rounded-lg" />
        </div>
        <div className="w-80 bg-white border-l border-gray-200 p-6">
          <Skeleton height={200} className="rounded-lg" />
        </div>
      </div>
    </div>
  );
});

GuideBuilderSkeleton.displayName = 'GuideBuilderSkeleton';

export default GuideBuilderSkeleton;
